'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function HashScrollHandler() {
  const router = useRouter();

  useEffect(() => {
    // Handle hash navigation on page load
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      }
    };

    // Check hash on load
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [router]);

  return null;
}
